<template>
  <div class="p-3 bg-white">
    <div id="AddTimeConditionFormContainer" class="vs-con-loading__container">
        <shared-time-conditions-add
          :activeKeyword="activeKeyword"
          :activeType="activeType"
          :hourOptions="hourOptions"
          :minuteOptions="minuteOptions"
          :weekDayOptions="weekDayOptions"
          :monthDayOptions="monthDayOptions"
          :monthOptions="monthOptions"
          @addTimeConditionSuccess="addTimeConditionSuccess"
        ></shared-time-conditions-add>

      <div class="text-center">
        <vs-button id="addTimeConditionButton" class="m-2" color="primary" type="filled" @click.prevent="addTimeConditions">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelAddTimeConditions">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import TimeCondition from '@/models/TimeCondition'
import SharedTimeConditionsAdd from '@/views/Shared/TimeConditions/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.TimeConditions.Add',
  components: {
    SharedTimeConditionsAdd
  },
  data () {
    return {
      amportal: false,
      activeKeyword: '',
      activeType: 'holiday',
      hourOptions: [],
      minuteOptions: [],
      weekDayOptions: [],
      monthOptions: [],
      monthDayOptions: []
    }
  },
  mounted () {
    this.activeKeyword = this.$route.params.keyword
    this.activeType = this.$route.params.type

    this.loadTimecondition()
  },
  methods: {
    async loadTimecondition () {
      this.$vs.loading({container: '#AddTimeConditionFormContainer'})

      const response = await TimeCondition.findAll({ keyword: this.activeKeyword, type: this.activeType })

      this.hourOptions = response.data.meta.options.hourOptions
      this.minuteOptions = response.data.meta.options.minuteOptions
      this.weekDayOptions = response.data.meta.options.weekDayOptions
      this.monthOptions = response.data.meta.options.monthOptions
      this.monthDayOptions = response.data.meta.options.monthDayOptions
      this.amportal = response.data.meta.amportal

      this.$vs.loading.close('#AddTimeConditionFormContainer > .con-vs-loading')
    },
    addTimeConditions () {
      EventBus.$emit('initSaveTimeCondition')
    },
    addTimeConditionSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_time_conditions_table')
      window.close()
    },
    cancelAddTimeConditions () {
      this.$windowOpenerHelper.notifyOpener('reload_time_conditions_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
